import SmartIndustrialMotor from "../../../../../assets/Courses/embeddedSystemsProjects/smartIndustrialMotorControlPWMCANProtocol.webp";
import RealTimeDataAcquisitionSystem from "../../../../../assets/Courses/embeddedSystemsProjects/realTimeDataAcquisitionSystemFreeRTOS.webp";
import EmbeddedLinuxBasedSmartHome  from "../../../../../assets/Courses/embeddedSystemsProjects/embeddedLinuxBasedSmartHomeAutomationSystem.webp";
import ARMCortexMBasedDigitalOscilloscope from "../../../../../assets/Courses/embeddedSystemsProjects/armCortexMBasedDigitalOscilloscope.webp";
import AIPoweredSmartCCTV from "../../../../../assets/Courses/embeddedSystemsProjects/aiPoweredSmartCCTVEmbeddedVisionOpenCV.webp";
import HandGestureRecognition from "../../../../../assets/Courses/embeddedSystemsProjects/handGestureRecognitionSmartControlEdgeAI.webp";
import TinyMLBasedVibrationAnalysis from "../../../../../assets/Courses/embeddedSystemsProjects/tinyMLBasedVibrationAnalysisPredictiveMaintenance.webp";
import AutomatedWarehouseRobot from "../../../../../assets/Courses/embeddedSystemsProjects/automatedWarehouseRobotwithLiDARBasedNavigation.webp";

import IoTBasedEnergyMeter from "../../../../../assets/Courses/embeddedSystemsProjects/iotBasedEnergyMeterusingESP32MQTT.webp";
import SmartAgriculturalIrrigation from "../../../../../assets/Courses/embeddedSystemsProjects/smartAgricultural IrrigationSystemLoRaSensors.webp";
import IndustrialIoTSmartbox from "../../../../../assets/Courses/embeddedSystemsProjects/industrialIoTSmartboxforPredictiveMaintenance.webp";
import RemoteAirQualityMonitoring from "../../../../../assets/Courses/embeddedSystemsProjects/remoteAirQualityMonitoringSystemSTM32Cloud.webp";

import IndustrialIoTGateway from "../../../../../assets/Courses/embeddedSystemsProjects/remoteAirQualityMonitoringSystemSTM32Cloud.webp";
import EmbeddedLinuxBased from "../../../../../assets/Courses/embeddedSystemsProjects/remoteAirQualityMonitoringSystemSTM32Cloud.webp";
import CustomLinuxKernelModule from "../../../../../assets/Courses/embeddedSystemsProjects/remoteAirQualityMonitoringSystemSTM32Cloud.webp";
import UBootCustomization from "../../../../../assets/Courses/embeddedSystemsProjects/remoteAirQualityMonitoringSystemSTM32Cloud.webp";
import RealTimeDataLoggingSystem from "../../../../../assets/Courses/embeddedSystemsProjects/remoteAirQualityMonitoringSystemSTM32Cloud.webp";
import CustomLinuxShellDevelopment from "../../../../../assets/Courses/embeddedSystemsProjects/remoteAirQualityMonitoringSystemSTM32Cloud.webp";

import TrustedExecutionEnvironment from "../../../../../assets/Courses/embeddedSystemsProjects/trustedExecutionEnvironmentSecureIoTDevices.webp";
import ADASBasedCollisionAvoidance from "../../../../../assets/Courses/embeddedSystemsProjects/adasBasedCollisionAvoidanceSystemUltrasonicAI.webp";
import SecureFirmwareUpdate from "../../../../../assets/Courses/embeddedSystemsProjects/secureFirmwareUpdateOTASystemIoTDevices.webp";
import AESRSAEncryption from "../../../../../assets/Courses/embeddedSystemsProjects/aesRSAEncryptionSecureEmbeddedCommunication.webp";
import VehicleECUSimulator from "../../../../../assets/Courses/embeddedSystemsProjects/vehicleECUSimulaCANProtocol.webp";
import OBDIIVehicleDiagnosticsSystem from "../../../../../assets/Courses/embeddedSystemsProjects/obdIIVehicleDiagnosticsSystemEmbeddedLinux.webp";
import ISOCompliantFunctionalSafety from "../../../../../assets/Courses/embeddedSystemsProjects/industrialIoTSmartboxforPredictiveMaintenance.webp";

const EmbeddedSystemsProjects = [
  {
    category: "EMBEDDED",
    learningPath: "Embedded Systems",
    projects: [
  {
    projectId: 1,
    projectTitle: "Smart Industrial Motor Control with PWM & CAN Protocol",
    videoUrl: "67f10d2062f75f283817c95a",
    image: SmartIndustrialMotor,
    completion: 0
  },
  {
    projectId: 2,
    projectTitle: "Real-Time Data Acquisition System using FreeRTOS",
    videoUrl: "67f10da6eb2ffd583474297f",
    image: RealTimeDataAcquisitionSystem,
    completion: 0
  },
  {
    projectId: 3,
    projectTitle: "Embedded Linux-Based Smart Home Automation System",
    videoUrl: "67f10e24944f5976baacb158",
    image: EmbeddedLinuxBasedSmartHome,
    completion: 0
  },
  {
    projectId: 4,
    projectTitle: "ARM Cortex-M Based Digital Oscilloscope",
    videoUrl: "67f10e95e2dc692b2a0e53ca",
    image: ARMCortexMBasedDigitalOscilloscope,
    completion: 0
  },
  // {
  //   projectId: 4,
  //   projectTitle: "Smart Shoe Development using ESP32 and Blynk",
  //   videoUrl: "6613a2284443c779482576e3",
  //   image: ARMCortexMBasedDigitalOscilloscope,
  // },
  {
    projectId: 5,
    projectTitle: "AI-Powered Smart CCTV with Embedded Vision & OpenCV",
    videoUrl: "67f10f47cc31b9138bf6c00a",
    image:  AIPoweredSmartCCTV,
    completion: 0
  },
  {
    projectId: 6,
    projectTitle: "Hand Gesture Recognition for Smart Control using Edge AI",
    videoUrl: "67f10feccaa5075d8a6ef8fa",
    image: HandGestureRecognition,
    completion: 0
  },
  {
    projectId: 7,
    projectTitle: "TinyML-Based Vibration Analysis for Predictive Maintenance",
    videoUrl: "67f110674ce5fc4a5ea17acf",
    image: TinyMLBasedVibrationAnalysis,
    completion: 0
  },
  {
    projectId: 8,
    projectTitle: "Automated Warehouse Robot with LiDAR-Based Navigation",
    videoUrl: "67f110e8f264b003d5cebbb6",
    image: AutomatedWarehouseRobot,
    completion: 0
  },
]
  }
];

const IoTEmbeddedSystemsProjects = [
  {
    category: "EMBEDDED",
    learningPath: "IoT and Embedded Systems",
    projects: [
    {
      projectId: 1,
      projectTitle: "IoT-Based Energy Meter using ESP32 & MQTT",
      videoUrl: "67f1118ad18b353b82f5e12d",
      image: IoTBasedEnergyMeter,
      completion: 0
    },
    {
      projectId: 2,
      projectTitle: "Smart Agricultural Irrigation System using LoRa & Sensors",
      videoUrl: "67f1120cef9ded35a3bb8f45",
      image: SmartAgriculturalIrrigation,
      completion: 0
    },
    {
      projectId: 3,
      projectTitle: "Industrial IoT (IIoT) Smartbox for Predictive Maintenance",
      videoUrl: "67f1127c4ce5fc4a5ea17bb1",
      image: IndustrialIoTSmartbox,
      completion: 0
    },
    {
      projectId: 4,
      projectTitle: "Remote Air Quality Monitoring System with STM32 & Cloud",
      videoUrl: "67f112edcaa5075d8a6efb07",
      image: RemoteAirQualityMonitoring,
      completion: 0
    },
    ]
  }
  ];

  const EmbeddedLinuxProjects = [
    {
      category: "EMBEDDED",
      learningPath: "Embedded Linux and System Development",
      projects: [
    {
      projectId: 1,
      projectTitle: "Industrial IoT Gateway Using Raspberry Pi",
      videoUrl: "67ee82b7e47698074f7eb454",
      image: IndustrialIoTGateway,
      completion: 0
    },
    {
      projectId: 2,
      projectTitle: "Embedded Linux-Based Smart Door Lock System",
      videoUrl: "67f11464d18b353b82f5e251",
      image: EmbeddedLinuxBased,
      completion: 0
    },
    {
      projectId: 3,
      projectTitle: "Custom Linux Kernel Module for Sensor Interface",
      videoUrl: "67f1152eb8a49f3ec1d228e5",
      image: CustomLinuxKernelModule,
      completion: 0
    },
    {
      projectId: 4,
      projectTitle: "U-Boot Customization and Secure Boot Implementation",
      videoUrl: "67f115d04ce5fc4a5ea17d55",
      image: UBootCustomization,
      completion: 0
    },
    {
      projectId: 5,
      projectTitle: "Real-Time Data Logging System Using Raspberry Pi",
      videoUrl: "67f1176ecc31b9138bf6c5b5",
      image:  RealTimeDataLoggingSystem,
      completion: 0
    },
    {
      projectId: 6,
      projectTitle: "Custom Linux Shell Development for Embedded Devices",
      videoUrl: "67f125e4caa5075d8a6f0359", 
      image: CustomLinuxShellDevelopment,
      completion: 0
    },
  ]
}
  ];

  const AutomotiveApplicationsProjects = [
    {
      category: "EMBEDDED",
      learningPath: "Embedded Systems for Automotive Applications",
      projects: [
    {
      projectId: 1,
      projectTitle: "Trusted Execution Environment (TEE) for Secure IoT Devices",
      videoUrl: "67f126c9f264b003d5cec4c7",
      image: TrustedExecutionEnvironment,
      completion: 0
    },
    {
      projectId: 2,
      projectTitle: "ADAS-Based Collision Avoidance System using Ultrasonic & AI",
      videoUrl: "67f127570293775fcf9511d8",
      image: ADASBasedCollisionAvoidance,
      completion: 0
    },
    {
      projectId: 3,
      projectTitle: "Secure Firmware Update & OTA System for IoT Devices",
      videoUrl: "67f127d60293775fcf9511f7",
      image: SecureFirmwareUpdate,
      completion: 0
    },
    {
      projectId: 4,
      projectTitle: "AES & RSA Encryption for Secure Embedded Communication",
      videoUrl: "67f12864f7ce53773830d3d1",
      image: AESRSAEncryption,
      completion: 0
    },
    {
      projectId: 5,
      projectTitle: "Vehicle ECU Simulator using CAN Protocol",
      videoUrl: "67f128dd1a657068a74bc970",
      image:  VehicleECUSimulator,
      completion: 0
    },
    {
      projectId: 6,
      projectTitle: "OBD-II Vehicle Diagnostics System with Embedded Linux",
      videoUrl: "67f1295872363224e0568dde", 
      image: OBDIIVehicleDiagnosticsSystem,
      completion: 0
    },
    {
      projectId: 7,
      projectTitle: "ISO 26262-Compliant Functional Safety Monitoring System",
      videoUrl: "67f129def7ce53773830d427",
      image: ISOCompliantFunctionalSafety,
      completion: 0
    },
  ]
}
];

export { EmbeddedSystemsProjects, IoTEmbeddedSystemsProjects, EmbeddedLinuxProjects, 
  AutomotiveApplicationsProjects };